window.chartImmobilie = {
	data: {
		// Liqui
		bruttowerte: [],
		nettowerte: [],
		verbindlichkeiten: [],
		einnahmen: [],
		ausgaben: [],
		kredit_einnahmen: [],
		kredit_ausgaben: [],
		saldo: [],
		// liquidierungen: [],
		// Steuer
		zves: [],
		steuereinnahmen: [],
		steuerausgaben: [],
		afas: [],
		// Sonstiges
		bewertungsdatum: 0,
		startdatum: 0,
		enddatum: 0,
		anzeigeformat: "jahr",
		status: "differenziert",
		vermoegenswertType: "",
		vermoegenswertId: "",
	},

	showLoading() {
		if (this.chart) this.chart.showLoading()
	},

	hideLoading() {
		if (this.chart) this.chart.hideLoading()
	},

	init() {
		this.chart = new Highcharts.stockChart("chart_immobilie", {
			chart: {
				chartType: "liqui", // ["liqui", "steuer"]
				events: {
					selection: function (event) {
						return zoomIn(chartImmobilie, event)
					},
				},
			},

			legend: {
				enabled: true,
			},

			yAxis: [
				{},
				{
					opposite: true,
				},
			],

			xAxis: {
				ordinal: false,
				min: this.data.startdatum,
				max: this.data.enddatum,
				plotLines: [
					{
						id: "bewertungsplotline",
						color: "#2F3435",
						width: 2,
						dashStyle: "longdashdot",
						zIndex: 10,
						bewertungsdatum: this.data.bewertungsdatum,
						value: this.data.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000, // Das Chart öffnet immer in der Jahresansicht
						label: {
							text: `Aktuelle Bewertung<br>zum ${moment(new Date(this.data.bewertungsdatum)).format("MM/YYYY")}`,
							rotation: 0,
							y: 15,
							x: 10,
							textAlign: "left",
							style: {
								color: chartFontColorGrau,
								fontSize: "14px",
							},
						},
					},
				],
				events: {
					afterSetExtremes: function (event) {
						const chart = event.target.chart,
							min = event.min,
							max = event.max

						updateDataGrouping(chart, min, max)
						updateBewertungPlotline(chart)
					},
				},
			},

			plotOptions: {
				column: {
					point: {
						events: {
							click: function () {
								const anzeigeformat = chartImmobilie.data.anzeigeformat
								const chartType = this.series.chart.options.chart.chartType
								const vmType = chartImmobilie.data.vermoegenswertType
								const vmId = chartImmobilie.data.vermoegenswertId

								detailansichtVermoegenswert(this.x, anzeigeformat, vmType, vmId, chartType)
							},
						},
					},
					cursor: "pointer",
				},
				series: {
					events: {
						legendItemClick: function () {
							if (this.userOptions.id == "verbindlichkeiten") {
								let saldo_series = this.chart.get("saldo")
								if (saldo_series.visible) {
									if (!this.visible) {
										this.chart.get("verbindlichkeiten").show()
										this.chart.get("kreditausgaben").hide()
										this.chart.get("krediteinnahmen").hide()
										return false
									}
								}
							}
						},
					},
				},
			},
			series: this.seriesLiqui(),
		})

		// Wenn der Chart Zeitraum kleiner ist als die Monatsgrenze das DataGrouping deaktivieren
		updateDataGrouping(this.chart, this.data.startdatum, this.data.enddatum)
	},

	update() {
		if (!this.chart) return

		this.chart.showLoading()

		const seriesArrays = [this.seriesLiqui(), this.seriesSteuer()]
		const alleSeries = [].concat(...seriesArrays)

		alleSeries.forEach((serie) => {
			const s = this.chart.get(serie.id)
			if (s) s.setData(serie.data, false)
		})

		// xAchse: Min und Max aktualisieren
		this.updateXAxisMinMax()

		// Bewertungsline aktualisieren
		this.updateBewertungLinie()

		this.chart.redraw({ duration: chartAnimationDuration })
		this.chart.hideLoading()
	},

	updateXAxisMinMax() {
		const seriesMaxValues = this.chart.series.map((serie) => (Array.isArray(serie.xData) ? serie.xData.slice(-1)[0] : undefined)),
			xAxisMaxValue = Math.max(this.data.enddatum, ...seriesMaxValues.filter((element) => element !== undefined))
		this.chart.xAxis[0].update({ min: this.data.startdatum, max: xAxisMaxValue })
	},

	updateBewertungLinie() {
		const plotLineOptions = this.chart.xAxis[0].options.plotLines[0]
		plotLineOptions.bewertungsdatum = this.data.bewertungsdatum
		plotLineOptions.value = this.data.bewertungsdatum
		plotLineOptions.label.text = `Aktuelle Bewertung<br>zum ${moment(new Date(this.data.bewertungsdatum)).format("MM / YYYY")}`

		if (this.chart.options.plotOptions.series.dataGrouping.enabled) {
			plotLineOptions.value = plotLineOptions.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000
		}

		this.chart.xAxis[0].options.plotLines[0] = Object.assign({}, this.chart.xAxis[0].options.plotLines[0], plotLineOptions)
	},

	updateSeriesData(seriesData, chartType) {
		// Alle Series entfernen
		while (this.chart.series.length > 0) {
			this.chart.series[0].remove(false)
		}

		// Series hinzufügen
		seriesData.forEach((serie) => {
			this.chart.addSeries(serie, false)
		})

		// XAchse Max Data prüfen und ggf. aktualisieren
		this.updateXAxisMinMax()

		// ChartType setzuen damit in der Detailansicht unterschieden werden kann ob liqui oder steuer
		this.chart.options.chart.chartType = chartType
		this.chart.redraw({ duration: chartAnimationDuration })
	},

	seriesLiqui() {
		return [
			{
				name: "Bruttowert",
				id: "bruttowert",
				legendName: "Bruttowert",
				yAxis: 0,
				type: "area",
				color: farbeBruttovermoegen,
				zIndex: 0,
				visible: false,
				data: this.data.bruttowerte,
			},
			{
				name: "Nettowert",
				id: "nettowert",
				legendName: "Nettowert",
				yAxis: 0,
				type: "area",
				color: farbeNettovermoegen,
				zIndex: 1,
				data: this.data.nettowerte,
			},
			{
				name: "Verbindlichkeiten",
				id: "verbindlichkeiten",
				legendName: "Verbindlichkeiten",
				yAxis: 0,
				type: "area",
				color: farbeVerbindlichkeiten,
				zIndex: 2,
				data: this.data.verbindlichkeiten,
			},
			{
				name: "Einnahmen",
				id: "einnahmen",
				legendName: "Einnahmen",
				yAxis: 1,
				type: "column",
				color: farbeEinnahmen,
				zIndex: 3,
				stack: "ein_ausgaben",
				visible: this.data.status == "differenziert" ? true : false,
				showInLegend: this.data.status == "differenziert" ? true : false,
				data: this.data.einnahmen,
			},
			{
				name: "Ausgaben",
				id: "ausgaben",
				legendName: "Ausgaben",
				yAxis: 1,
				type: "column",
				color: farbeAusgaben,
				zIndex: 3,
				stack: "ein_ausgaben",
				visible: this.data.status == "differenziert" ? true : false,
				showInLegend: this.data.status == "differenziert" ? true : false,
				data: this.data.ausgaben,
			},
			{
				name: "Krediteinnahmen",
				id: "krediteinnahmen",
				yAxis: 1,
				type: "column",
				color: farbeVerbindlichkeitenColumn,
				zIndex: 3,
				index: 1,
				stack: "ein_ausgaben",
				linkedTo: "verbindlichkeiten",
				visible: this.data.status == "differenziert" ? true : false,
				showInLegend: false,
				data: this.data.kredit_einnahmen,
			},
			{
				name: "Kreditausgaben",
				id: "kreditausgaben",
				yAxis: 1,
				type: "column",
				color: farbeVerbindlichkeitenColumn,
				zIndex: 3,
				index: 2,
				visible: this.data.status == "differenziert" ? true : false,
				showInLegend: false,
				stack: "ein_ausgaben",
				linkedTo: "verbindlichkeiten",
				data: this.data.kredit_ausgaben,
			},
			{
				name: "Saldo",
				id: "saldo",
				legendName: "Saldo",
				yAxis: 1,
				type: "column",
				color: farbeEinnahmen,
				negativeColor: farbeAusgaben,
				zIndex: 3,
				visible: this.data.status == "differenziert" ? false : true,
				showInLegend: this.data.status == "differenziert" ? false : true,
				stack: "ein_ausgaben",
				data: this.data.saldo,
			},
			// {
			// 	name: "Automatische Liquidierung",
			// 	id: "liquidierung",
			// 	legendName: "Cash - Pooling",
			// 	yAxis: 1,
			// 	type: "column",
			// 	color: farbeLiquidierung,
			// 	zIndex: 3,
			// 	index: 1,
			// 	stack: "ein_ausgaben",
			// 	data: this.data.liquidierungen,
			// },
		]
	},

	seriesSteuer() {
		return [
			{
				name: "steuerpflichtiges Einkommen",
				id: "zves",
				legendName: "steuerpflichtiges Einkommen",
				type: "column",
				color: farbeZuVersteuerndesEinkommen,
				stack: "steuereinkommen",
				data: this.data.zves,
			},
			{
				name: "AfA",
				id: "afas",
				legendName: "AfA",
				type: "column",
				visible: false,
				color: farbeSteuererstattung, //'#C5E6A6', //'#AAD2BA', //
				stack: "differenziert",
				data: this.data.afas,
			},
			{
				name: "Einnahmen",
				id: "steuereinnahmen",
				legendName: "Einnahmen",
				type: "column",
				visible: false,
				color: farbeEinnahmen,
				stack: "differenziert",
				data: this.data.steuereinnahmen,
			},
			{
				name: "Ausgaben",
				id: "steuerausgaben",
				legendName: "Ausgaben",
				type: "column",
				visible: false,
				stack: "differenziert",
				color: farbeAusgaben,
				data: this.data.steuerausgaben,
			},
		]
	},
}
